import { Component, OnInit, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
  FormlyModule,
} from '@ngx-formly/core';
import { VectronicValidators } from '@vectronic/util';
import { CustomErrorStateMatcher } from '../../utils/custom-error-state-matcher';

export interface FormlyEmailFieldConfig extends FormlyFieldConfig<FormlyFieldProps> {
  type: 'email' | Type<EmailComponent>;
}

@Component({
  selector: 'vectronic-formly-email',
  imports: [MatFormFieldModule, ReactiveFormsModule, MatInputModule, FormlyModule],
  templateUrl: './email.component.html',
  styles: [
    `
      mat-form-field {
        display: block;
      }

      span[matTextSuffix] {
        margin-left: 0.5rem;
      }

      span[matTextPrefix] {
        margin-right: 0.5rem;
      }
    `,
  ],
})
export class EmailComponent extends FieldType<FieldTypeConfig<FormlyFieldProps>> implements OnInit {
  matcher = new CustomErrorStateMatcher();

  ngOnInit() {
    this.formControl.addValidators([VectronicValidators.email]);
  }
}
